import React, { useState, useEffect, useRef } from 'react';
import Image from './image';
import _ from 'lodash';

export default function ImageModule({ parameters, enableModuleLogging, addLogEntry }) {
    const imageModuleRef = useRef(null);
    const [containerHeight, setContainerHeight] = useState(0);
    const [containerWidth, setContainerWidth] = useState(0);

    const url = parameters.userProfile.serverIP + '/images/' +
        parameters.userProfile.customer_id + '/' +
        parameters.userProfile.site_id + '/' +
        parameters.config.event_id + '/' +
        parameters.config.description;

    useEffect(() => {
        enableModuleLogging();
        const parent = imageModuleRef.current.parentElement.parentElement;
        addLogEntry('Init dimensions: ' + parent.offsetHeight + '/' + parent.offsetWidth);
        setContainerHeight(parent.offsetHeight);
        setContainerWidth(parent.offsetWidth);
        addLogEntry('Image URL: ' + url);

        const handleResize = _.debounce(() => {
            if (!imageModuleRef.current) return;
            const p = imageModuleRef.current.parentElement.parentElement;
            addLogEntry('Screen resized:: ' + p.offsetHeight + '/' + p.offsetWidth);
            setContainerHeight(p.offsetHeight);
            setContainerWidth(p.offsetWidth);
        }, 400);

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div ref={imageModuleRef}>
            <Image src={url} width={containerWidth} height={containerHeight} mode='fit' />
        </div>
    );
}
